import { formatCurrency, formatDateTime, formatNumber } from '@/lib/campaign-dashboard'
import type {
  CampaignRecentDonor,
  CampaignRecentSale,
} from '@/types/campaign-report'
import styles from './CampaignDashboard.module.css'

interface CampaignDashboardRecentActivityProps {
  recentDonors: CampaignRecentDonor[]
  recentSales: CampaignRecentSale[]
}

export function CampaignDashboardRecentActivity({
  recentDonors,
  recentSales,
}: CampaignDashboardRecentActivityProps) {
  return (
    <section className={styles.sectionCard}>
      <div className={styles.sectionHeader}>
        <div>
          <h2 className={styles.sectionTitle}>Atividade recente</h2>
          <p className={styles.sectionSubtitle}>
            Ultimos compradores e ultimas vendas recebidas pela campanha.
          </p>
        </div>
      </div>

      <div className={styles.activityGrid}>
        <article className={styles.activityCard}>
          <div className={styles.activityHeader}>
            <div>
              <h3 className={styles.sectionTitle}>Ultimos compradores</h3>
              <p className={styles.sectionSubtitle}>
                Ordenacao original retornada pelo backend.
              </p>
            </div>
          </div>

          <div className={styles.activityList}>
            {recentDonors.length === 0 ? (
              <p className={styles.tableMuted}>Nenhum comprador recente encontrado.</p>
            ) : (
              recentDonors.map((donor) => (
                <div key={donor.donor_id} className={styles.activityItem}>
                  <div>
                    <p className={styles.tableName}>{donor.name}</p>
                    <p className={styles.tableMuted}>
                      {donor.email || 'Sem email'} · {donor.phone || 'Sem telefone'}
                    </p>
                    <p className={styles.tableMuted}>
                      Ultimo pagamento: {formatDateTime(donor.last_payment_paid_at)}
                    </p>
                  </div>
                  <div>
                    <div className={styles.activityValue}>
                      {formatCurrency(donor.last_payment_amount)}
                    </div>
                    <p className={styles.tableMuted}>
                      Total: {formatCurrency(donor.total_amount_in_campaign)}
                    </p>
                  </div>
                </div>
              ))
            )}
          </div>
        </article>

        <article className={styles.activityCard}>
          <div className={styles.activityHeader}>
            <div>
              <h3 className={styles.sectionTitle}>Ultimas vendas</h3>
              <p className={styles.sectionSubtitle}>
                Pagamentos confirmados mais recentes da campanha.
              </p>
            </div>
          </div>

          <div className={styles.activityList}>
            {recentSales.length === 0 ? (
              <p className={styles.tableMuted}>Nenhuma venda recente encontrada.</p>
            ) : (
              recentSales.map((sale) => (
                <div key={sale.payment_id} className={styles.activityItem}>
                  <div>
                    <p className={styles.tableName}>
                      {sale.donor_name || 'Comprador nao identificado'}
                    </p>
                    <p className={styles.tableMuted}>
                      {sale.email || 'Sem email'} · {formatDateTime(sale.paid_at)}
                    </p>
                    <p className={styles.tableMuted}>
                      {formatNumber(sale.quantity)} numeros
                    </p>
                  </div>
                  <div className={styles.activityValue}>{formatCurrency(sale.amount)}</div>
                </div>
              ))
            )}
          </div>
        </article>
      </div>
    </section>
  )
}
